/** @jsx jsx */
import {jsx} from 'theme-ui'
import {useTranslation} from 'react-i18next'

type Props = {}

const PaymentFormPayPal: React.FC<Props> = () => {
  const {t} = useTranslation()
  return (
    <div
      sx={{
        pt: 16,
        px: 12,
        pb: 26,
      }}
    >
      <p>{t('paypalRedirectionNotice')}</p>
    </div>
  )
}

export default PaymentFormPayPal
